/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_Site_Thigh_LeftInputs */

const en_us2_body_measures_site_thigh_left = /** @type {(inputs: Body_Measures_Site_Thigh_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Left thigh`)
};

const pt_br2_body_measures_site_thigh_left = /** @type {(inputs: Body_Measures_Site_Thigh_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coxa esq.`)
};

const es_419_body_measures_site_thigh_left = /** @type {(inputs: Body_Measures_Site_Thigh_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muslo izq.`)
};

const pt_pt2_body_measures_site_thigh_left = /** @type {(inputs: Body_Measures_Site_Thigh_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coxa esq.`)
};

const fr_fr2_body_measures_site_thigh_left = /** @type {(inputs: Body_Measures_Site_Thigh_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuisse gauche`)
};

const de_de2_body_measures_site_thigh_left = /** @type {(inputs: Body_Measures_Site_Thigh_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oberschenkel li.`)
};

const it_it2_body_measures_site_thigh_left = /** @type {(inputs: Body_Measures_Site_Thigh_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coscia sx`)
};

/**
* | output |
* | --- |
* | "Left thigh" |
*
* @param {Body_Measures_Site_Thigh_LeftInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_site_thigh_left = /** @type {((inputs?: Body_Measures_Site_Thigh_LeftInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_Site_Thigh_LeftInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_site_thigh_left(inputs)
	if (locale === "es-419") return es_419_body_measures_site_thigh_left(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_site_thigh_left(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_site_thigh_left(inputs)
	if (locale === "de-DE") return de_de2_body_measures_site_thigh_left(inputs)
	if (locale === "it-IT") return it_it2_body_measures_site_thigh_left(inputs)
	return en_us2_body_measures_site_thigh_left(inputs)
});
export { body_measures_site_thigh_left as "body-measures.site_thigh_left" }